// GL6 — create / send-link formlarının ORTAK iletişim kuralları (GL3 §5.10.1 aynası). Metin yok: anahtarlar.
import type { TFunction } from 'i18next';
import { z } from 'zod';
import {
  type InviteContactField,
  type InviteFieldError,
  type InviteFieldErrorCode,
  inviteContactIssues,
  inviteFieldErrors,
} from '../api/contractors';
import { hasErrorCode } from '../api/errors';

export const CONTACT_ERROR_KEYS: Record<
  InviteFieldErrorCode,
  Record<InviteContactField, string>
> = {
  REQUIRED: {
    email: 'personnelLink.validation.contactRequired',
    phone: 'personnelLink.validation.contactRequired',
  },
  INVALID: {
    email: 'personnelLink.validation.emailInvalid',
    phone: 'personnelLink.validation.phoneInvalid',
  },
  TAKEN: {
    email: 'personnelLink.validation.emailTaken',
    phone: 'personnelLink.validation.phoneTaken',
  },
};

/** Create'te iki alan da boş GEÇERLİDİR (bağlantı yok); dolu alan yine biçimli olmalı. */
export function createContactIssues(email: string, phone: string): InviteFieldError[] {
  if (email.trim() === '' && phone.trim() === '') {
    return [];
  }
  return inviteContactIssues(email, phone);
}

/** İki iletişim de dolu mu — kanal seçimi yalnız o zaman görünür / gider (GL3 §5.2). */
export function bothContactsFilled(email: string, phone: string): boolean {
  return email.trim() !== '' && phone.trim() !== '';
}

/** İstemci tarafı iletişim sorunlarını zod `superRefine` bağlamına, alan yoluyla ekler. */
export function addContactIssues(
  ctx: z.RefinementCtx,
  issues: InviteFieldError[],
  t: TFunction,
): void {
  for (const issue of issues) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: [issue.field],
      message: t(CONTACT_ERROR_KEYS[issue.code][issue.field]),
    });
  }
}

/** Sunucunun alan-bağlı iletişim hataları → nötr alan metni (`TAKEN` dahil; D1: "başka hesapta" metni asla). */
export function inviteServerFieldErrors(
  error: unknown,
  t: TFunction,
): Array<{ field: InviteContactField; message: string }> {
  return inviteFieldErrors(error).map((e) => ({
    field: e.field,
    message: t(CONTACT_ERROR_KEYS[e.code][e.field]),
  }));
}

/** `INVITE_CHANNEL_UNAVAILABLE` yalnız iki iletişim birlikte gönderildiğinde kanal seçimine aittir. */
export function isChannelUnavailable(error: unknown, bothContacts: boolean): boolean {
  return bothContacts && hasErrorCode(error, 'INVITE_CHANNEL_UNAVAILABLE');
}
